module.exports = __webpack_public_path__ + "img/130.c3e8f426.jpg";